import Image from '@atlaskit/image';
import layoutAnatomyLight from "../../../../../../packages/design-system/navigation-system/constellation/layout/images/layout-anatomy-light.png";
import layoutAnatomyDark from "../../../../../../packages/design-system/navigation-system/constellation/layout/images/layout-anatomy-dark.png";
import layoutDoLight from "../../../../../../packages/design-system/navigation-system/constellation/layout/images/layout-do-light.png";
import layoutDoDark from "../../../../../../packages/design-system/navigation-system/constellation/layout/images/layout-do-dark.png";
import layoutDontLight from "../../../../../../packages/design-system/navigation-system/constellation/layout/images/layout-dont-light.png";
import layoutDontDark from "../../../../../../packages/design-system/navigation-system/constellation/layout/images/layout-dont-dark.png";
import SectionMessage from '@atlaskit/section-message';
import * as React from 'react';
export default {
  Image,
  layoutAnatomyLight,
  layoutAnatomyDark,
  layoutDoLight,
  layoutDoDark,
  layoutDontLight,
  layoutDontDark,
  SectionMessage,
  React
};